import { Route, Routes } from "react-router-dom";
import CompareWithOdoo from "./CompareWithOdoo";

const FSIStockPage = () => (
  <Routes>
    <Route>
      <Route index element={<CompareWithOdoo />} />
    </Route>
  </Routes>
);

export default FSIStockPage;
